import SweetScroll from 'sweet-scroll';
import Validator from '@/js/modules/Validator';
import { detectLocaleByHtml } from '@/js/utils/browser';

// Schema
import schema, { MESSAGES } from '@/js/data/schema';

export default class {
  constructor (selector) {
    const { locale } = detectLocaleByHtml();

    this.selector = selector;
    this.el = document.querySelector(selector);
    this.headerEl = document.querySelector('.l-header'); // NOTE: selectorを付与した方がよいがDOM変更せずに適用
    if (!this.el) {
      return;
    }
    this.textarea = [...this.el.querySelectorAll('textarea')];

    this.config = {
      fieldRootSelector: '[data-field-id]',
      confirmStateClass: '-state-confirm'
    };

    this.scroller = new SweetScroll({
      duration: 800,
      easing: 'easeOutQuint'
    });

    /**
     * @doc タイプごとのフィールドセット
     * all すべてのフィールド
     */
    this.showFieldformats = {
      all: [
        'contact_type',
        'name_first',
        'name_last',
        'email',
        'phone',
        'contact_body',
        '1',
        ...(locale === 'ja' ? ['name_kana'] : [])
      ]
    };

    if (!this.el) {
      return;
    }

    this._bind();

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', this._initialize);
    } else {
      this._initialize();
    }
  }

  _bind () {
    this._onConfirm = this._onConfirm.bind(this);
    this._onBack = this._onBack.bind(this);
    this._initialize = this._initialize.bind(this);
    this._changeAgreementState = this._changeAgreementState.bind(this);
    this._updateSchema = this._updateSchema.bind(this);
    this._updateFormType = this._updateFormType.bind(this);
    // this._onChangeType = this._onChangeType.bind(this);
  }

  async _initialize () {
    const submitButton = document.querySelector('[type="submit"]');
    const confirmButton = document.querySelector('.js-form-confirm');
    const backButton = document.querySelector('.js-form-back');

    this.agreementCheckField = document.querySelector('.js-form-agree');
    this.agreementCheckBox = this.agreementCheckField.querySelector('input[type="checkbox"]');
    this.agreementCheckFieldError = this.agreementCheckField.querySelector('[data-field-error]');
    this.submitButton = submitButton;
    this.confirmButton = confirmButton;
    this.backButton = backButton;

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', this._onConfirm);
    }

    if (this.backButton) {
      this.backButton.addEventListener('click', this._onBack);
    }

    this.showFields = [...document.querySelectorAll(`${this.config.fieldRootSelector}:has([data-field])`)];
    this.typeSelect = document.querySelector('[name="contact_type"]');

    this.agreementCheckBox.addEventListener('change', this._changeAgreementState);
    // this.typeSelect.addEventListener('change', this._onChangeType);

    const schemaId = this._updateFormType();

    this.validator = new Validator(this.selector, {
      schema: schema[schemaId],
      options: {
        realtime: true,
        errorToScrollSelector: '.o-form',
        on: {
          ready: state => {
            if (state.errors.length) {
              return;
            }
            if (confirmButton.checked) {
              confirmButton.checked = false;
            }
          },
          validate: (state, event) => {
            if (!confirmButton) {
              return;
            }
            const hasError = Boolean(state.errors.length);
            const isChecked = this.agreementCheckBox.checked;
            const isInvalid = hasError || !isChecked;

            if (!state.ready) {
              return;
            }

            if (isInvalid) {
              document.documentElement.classList.add('has-validate-error');
            } else {
              document.documentElement.classList.remove('has-validate-error');
            }
            confirmButton.disabled = isInvalid;
          }
        }
      }
    });

    await this._updateSchema(schemaId);
  }

  _changeAgreementState (event) {
    const isTrusty = event.target.checked;
    if (isTrusty) {
      this.agreementCheckField.classList.remove('has-error');
      this.agreementCheckFieldError.innerText = '';
      this.agreementCheckBox.setAttribute('aria-invalid', 'false');
    } else {
      this.agreementCheckField.classList.add('has-error');
      this.agreementCheckFieldError.innerText = MESSAGES.MUST_BE_TRUE.privacy;
      this.agreementCheckBox.setAttribute('aria-invalid', 'true');
    }
  }

  _updateFormType () {
    // const typeField = document.querySelector('[name="contact_type"]');
    // const selectedValue = typeField.options[typeField.selectedIndex || 0].value;
    const currentType = 'all';

    this.el.setAttribute('data-form-id', currentType);

    return currentType;
  }

  async _updateSchema (schemaId) {
    const fieldFormat = this.showFieldformats[schemaId];
    const newSchema = schema[schemaId];

    // 表示するフィールドを条件により切り替え
    this.showFields.forEach(fieldRoot => {
      const isExists = fieldFormat.includes(fieldRoot.dataset.fieldId);
      if (fieldRoot) {
        if (isExists) {
          fieldRoot.style.display = '';
        } else {
          fieldRoot.style.display = 'none';
        }
      }
    });

    // バリデーションのスキーマを更新
    await this.validator.updateSchema(this.el, newSchema);
  }

  async _onConfirm (event) {
    event.preventDefault();
    // フォーム全体のバリデーションを実施
    const errors = await this.validator.validate(this.el);
    if (errors.length > 0) {
      // エラーがある場合は、エラーメッセージの表示などをそのままにして終了
      return;
    }

    this.textarea.forEach(textarea => {
      this.setTextareaHeight(textarea);
    });
    // エラーがなければ確認状態に遷移
    this.el.classList.add(this.config.confirmStateClass);

    this.scroller.toElement(this.el, {
      offset: -(this.headerEl ? this.headerEl.offsetHeight + 50 : 50)
    });
  }

  _onBack (event) {
    event.preventDefault();
    const form = this.el;

    this.textarea.forEach(textarea => {
      this.removeTextareaHeight(textarea);
    });
    // 確認状態を解除
    form.classList.remove(this.config.confirmStateClass);
  }

  /**
   * @doc CSSのサポート状況を鑑みpolyfillを同時に適用
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/field-sizing
   */
  setTextareaHeight (textarea) {
    const adjustHeight = () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    };
    adjustHeight();
    textarea.addEventListener('input', adjustHeight);
    window.addEventListener('resize', adjustHeight);
  }

  removeTextareaHeight (textarea) {
    textarea.style.height = '';
  }

  // async _onChangeType () {
  //   const currentType = this._updateFormType();
  //   await this._updateSchema(currentType);
  // }
}
